import React from "react";
import { Tabs } from "antd";
import TimesheetReport from "./TimesheetReport";
import TimesheetReportDetail from "./TimesheetReportDetail";
import Squarings from "./Squarings";
import PlannedVsTimesheetReport from "./PlannedVsTimesheetReport";
import { useTranslation } from "react-i18next";
import { reportTimesheet } from "../../../utils/properties";

const TimesheetReportTabs = () => {
  const { t } = useTranslation();
  const mappingKeyReports = {
    TimesheetReport: <TimesheetReport />,
    TimesheetReportDetail: <TimesheetReportDetail />,
    Squarings: <Squarings />,
    PlannedVsTimesheetReport: <PlannedVsTimesheetReport />,
  };
  return (
    <Tabs
      className="PFtabs"
      defaultActiveKey={0}
      items={reportTimesheet.map((r, i) => ({
        label: t(`timesheet.report.${r.name}`),
        key: i,
        children: mappingKeyReports[r.component],
      }))}
    />
  );
};

export default TimesheetReportTabs;
